import {gsap} from "../LibrariesImport";

export default class BlockDataSlider {
	static init() {
		this.blocks = document.querySelectorAll(".block-data-slider");

		if (!this.blocks) {
			return;
		}

		this.buildBlocks();
	}

	static buildBlocks() {
		this.blocks.forEach(block => {
			this.initSlider(block);
		});
	}

	static initSlider(block) {
		const stage = block.querySelector(".data-slider-scrollable");
		const drag = block.querySelector(".swiper-scrollbar");
		new Swiper(stage, {
			loop: false,
			grabCursor: true,
			slidesPerView: "auto",
			spaceBetween: 10,
			speed: 500,
			touchEventsTarget: "container",
			mousewheel: {
				enabled: true,
				releaseOnEdges: true,
				forceToAxis: true,
			},
			scrollbar: {
				el: drag,
				draggable: true,
				snapOnRelease: false,
			}
		});
	}
}
